import { render, staticRenderFns } from "./statistical-analysis-view-detail-chart-filters-extended.vue?vue&type=template&id=a0c447e6&scoped=true&"
import script from "./statistical-analysis-view-detail-chart-filters-extended.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-view-detail-chart-filters-extended.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-view-detail-chart-filters-extended.scss?vue&type=style&index=0&id=a0c447e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c447e6",
  null
  
)

export default component.exports